module.exports = __webpack_public_path__ + "img/vr_emo_estimate.d020b5e9.png";